import { ExternalLinkIcon } from '@chakra-ui/icons';
import {
  AspectRatio,
  Box,
  Button,
  Flex,
  Image,
  Stack,
  Text,
  useMediaQuery,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { RHeader } from '../../../shared/components/header';

export const RedirectionShop: React.FC = () => {
  const [isLargerThan800] = useMediaQuery('(min-width: 800px)');
  return (

    <Flex mt={20}>
      <Stack direction={isLargerThan800 ? 'row' : 'column'} gap={4} w='100%'>
        <VStack alignItems='flex-start' w='100%'>
          <RHeader
            header='Online zu Ihrem Wunschkennzeichen'
            description='BEQUEM VON ZUHAUSE'
          />
          <Text align='left'>
            Sehr geehrter Kunde, gerne leiten wir Sie zu unserem Onlineshop weiter. Dort können Sie die Schilder einfach und bequem bestellen. Bitte beachten Sie, dass eine Abholung der Schilder vor Ort leider nicht möglich ist.
          </Text>

        </VStack>
        <AspectRatio w='100%' ratio={16 / 9}>

          <Box bg='gray.200' borderRadius={8} width="100%">
            <Box position="absolute" opacity="0.2" width="200%" height="200%" transform="rotate(30deg)" backgroundImage={"/images/license_plate.svg"} backgroundRepeat={"repeat"} backgroundSize={178}></Box>
            <Stack>
              <Link target="_blank" to={"https://www.wunschkennzeichenprofi.shop/wunschkennzeichen"}>
                <Button variant='solid' colorScheme='blue' rightIcon={<ExternalLinkIcon />}>
                  Jetzt weiterleiten
                </Button>
              </Link>
            </Stack>
          </Box>

        </AspectRatio>
      </Stack>
    </Flex>
  );
};
